// This Collapser is used in the Ferry Discount page but we don't need to load it because it's also loaded by the Faqs subpage.
// import {collapserLoader} from "../../../rankers/components/collapser/collapser_loader";
// collapserLoader();

import {memberOfferAcceptorLoader} from "../../../rankers/components/member_offer_acceptor/member_offer_acceptor_loader";
memberOfferAcceptorLoader();

import { promocodeLoader } from '../../../rankers/components/promocode/promocode_loader';
promocodeLoader();

import { breakpointerLoader } from "../../../rankers/components/breakpointer/breakpointer_loader";
breakpointerLoader();
